import FetchApiError from "@/lib/openapi/api-error";
import {
  ExtractFetchParams,
  ExtractMutationOptions,
  ExtractResponse,
  useMutationRequest,
} from "@/lib/openapi/hooks";
import { useQueryClient } from "@tanstack/react-query";
import useUserSwitchAnimation from "./use-user-switch-animation";

export type PostSwitchResponse = ExtractResponse<
  "telegramAuthorization",
  "/users/switch",
  "post"
>;

export type PostSwitchFetchParams = ExtractFetchParams<
  "telegramAuthorization",
  "/users/switch",
  "post"
>;

export const usePostSwitchMutate = ({
  queryOptions,
}: {
  queryOptions?: ExtractMutationOptions<
    PostSwitchResponse,
    FetchApiError,
    PostSwitchFetchParams,
    unknown
  >;
} = {}) => {
  const queryClient = useQueryClient();
  const { disableSwipeMode } = useUserSwitchAnimation();
  return useMutationRequest("telegramAuthorization", "/users/switch", {
    method: "post",
    queryOptions: {
      onSuccess: async (...args) => {
        disableSwipeMode();
        await queryClient.invalidateQueries();
        queryOptions?.onSuccess?.(...args);
      },
    },
  });
};

export default usePostSwitchMutate;
